import React, { useState } from "react";
import { Icon } from "@synergy/icons";
import { Col, Flex, Row } from "antd"; // Importações de componentes de layout e UI da biblioteca Ant Design
import { useTranslation } from "react-i18next"; // Importação do hook useTranslation do react-i18next para usar traduções no componente
import styled from "styled-components"; // Importação de 'styled-components' para criar componentes de estilo CSS em JS
import { useGlobalFilterContext } from "../../../../../contexts/GlobalFilterProvider";
import Theme from "../../../../../styles/Theme/Theme"; // Importação do tema da aplicação para acessar variáveis de estilo
import { Dropdown } from "../../../Atomics/Dropdown";
import { Weather } from "../../../Atomics/Weather";
import { MapFilterComponent } from "../MapFilterComponent";
import { LeftIncidentsWidgetsOverlay } from "./IncidentsWidgetsOverlay/LeftIncidentsWidgetsOverlay";
import { LeftServicesWidgetsOverlay } from "./ServicesWidgetsOverlay/LeftServicesWidgetsOverlay";
import { MapPopUpConfigurations } from "./MapPopUpConfigurations";

//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const OverlayStyles = styled.div`
  height: Calc(100vh - 152px);
  width: 100%;
  pointer-events: none;

  .overlay-widget {
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.15);
    border-radius: ${Theme.radius["lg"]};
    width: 100%;

    &.field {
      padding: ${Theme.spacing.s02} ${Theme.spacing.s03};
    }
  }
`;

const IconDropdown = styled.div`
  box-shadow: ${Theme.shadow.level3};
  border-radius: 30px;
  width: fit-content;
  margin-left: 10px;
  display: flex;
  background-color: white;
  padding: 5px 5px;
  margin-top: 10px;
  font-weight: 500;

  :hover {
    cursor: pointer;
  }

  p {
    display: flex;
    margin: 0;
    margin-top: 5px;//Needs this to center, otherwise it will be a little bit down (to display align center it needs change in the icon)
    color: ${Theme.color["blue-4"]};
  }

  .threeDParagraph {
    display: flex;
    margin: 0;
    margin-top: 5px;//Needs to be like his to center, otherwise it will be a little bit down (to display align center it needs change in the icon)
    color: ${Theme.color["blue-4"]};
  }

  .marginLeft {
    margin-left: 10px;
    font-weight: 400;
  }
`;
//#endregion

// Componente funcional para sobreposição de widgets
export const WidgetsOverlay = ({
  mapPois,
  copyMapPois,
  selectedLayer,
  subEntity,
  filterPOIs,
  openClusterDrawer,
  setIsOnCreateIncidentMode
}) => {
  const { classes, setClasses, dropdownClasses, prioritiesSelected, setPrioritiesSelected, prioritiesDropdown, severitySelected, setSeveritySelected, setIsClassesFetching } = useGlobalFilterContext();
  const [openModalMapConfigurations, setOpenModalMapConfigurations] = useState(false);

  function optionClassesChange(newClasses) {
    if (JSON.stringify(classes) !== JSON.stringify(newClasses)) {
      setClasses(newClasses);
      filterPOIs(newClasses?.map((x) => x.value), 'class');
    }
  }

  function optionPriorityChange(newPriorities) {
    if (JSON.stringify(prioritiesSelected) !== JSON.stringify(newPriorities)) {
      setPrioritiesSelected(newPriorities);
      filterPOIs(newPriorities?.map((x) => x.value), 'priority');
    }
  }

  function optionSeverityChange(newSeverities) {
    if (JSON.stringify(severitySelected) !== JSON.stringify(newSeverities)) {
      setSeveritySelected(newSeverities);
      filterPOIs(newSeverities?.map((x) => x.value), 'severity');
    }
  }

  return (
    <OverlayStyles>
      <Row>
        <Col span={6}>
          <Flex vertical gap="middle">
            <Row gutter={[Theme.spacing["s03"], Theme.spacing["s03"]]}>
              {" "}
              <Col span={24}>
                <Weather tenant={subEntity?.value} />
              </Col>
              {selectedLayer === "Incidents" ? (
                <LeftIncidentsWidgetsOverlay mapPois={copyMapPois} classes={classes} />
              )
                // :
                // selectedLayer === 'Services' ? (
                //   <LeftServicesWidgetsOverlay classes={classes} />
                // )
                  : null}
            </Row>
          </Flex>
        </Col>

        {/* Dropdwons a meio da pagina */}
        <Col span={selectedLayer === 'Incidents' ? 10 : 7} offset={selectedLayer === 'Incidents' ? 1 : 2}>
          <div style={{ pointerEvents: "auto" }}>
            {mapPois?.length > 0 && dropdownClasses && classes ? (
              <MapFilterComponent dropdownClasses={dropdownClasses} classes={classes} optionClassesChange={optionClassesChange} selectedLayer={selectedLayer}
                prioritiesDropdown={prioritiesDropdown} prioritiesSelected={prioritiesSelected} optionPriorityChange={optionPriorityChange}
                optionSeverityChange={optionSeverityChange} />
            ) : null}
          </div>
        </Col>

        {/* Coluna direita para dropdown de camadas */}
        <Col span={7} offset={selectedLayer === 'Incidents' ? 0 : 2}>
          <Row gutter={[Theme.spacing["s03"], Theme.spacing["s03"]]}>
            <Col span={24} style={{ pointerEvents: "auto", display: "flex", justifyContent: "flex-end" }}>
              <MapDropdowns
                openClusterDrawer={openClusterDrawer}
                setIsOnCreateIncidentMode={setIsOnCreateIncidentMode}
                openMapConfigurations={() => setOpenModalMapConfigurations(true)}
                setIsClassesFetching={setIsClassesFetching}
              />
            </Col>
          </Row>
        </Col>
      </Row>

      <MapPopUpConfigurations isModalOpen={openModalMapConfigurations} handleCancel={() => setOpenModalMapConfigurations(false)} />
    </OverlayStyles>
  );
};

// Componente funcional para dropdown de camadas
const MapDropdowns = ({ openClusterDrawer, setIsOnCreateIncidentMode, openMapConfigurations, setIsClassesFetching }) => {
  const { t } = useTranslation();
  const { selectedLayer, setSelectedLayer, layersDropdown } = useGlobalFilterContext();

  const items = layersDropdown.map((item, index) => (
    <li onClick={() => { setIsClassesFetching(true); setSelectedLayer(item.value) }} key={index}
      style={{ fontWeight: item.value === selectedLayer ? '500' : null }}>{t('button.' + item.label)}</li>
  ));

  //the dropdown is triggered by the 'IconDropdown' component and is rendered using the dropdown from Ant Design
  return (
    <>
      {/* <IconDropdown onClick={(e) => { e.preventDefault(); setIsOnCreateIncidentMode() }}>
        <p className="marginLeft">{t('button.create_incident')}</p>
        <Icon
          iconsize={"md"}
          icon={"Plus"}
          color={"blue-4"}
          bgColor={"white"}
          strokeWidth="2"
        />
      </IconDropdown> */}

      <div style={{ marginTop: '10px', marginLeft: '10px' }}>
        <Dropdown title={t('button.' + layersDropdown?.find(x => x.value === selectedLayer)?.label)}
          preIcon="Layers" postIcon='true' boxshadow='true' selectedValue={selectedLayer}>
          {items}
        </Dropdown>
      </div>


      <IconDropdown onClick={openClusterDrawer}>
        <Icon
          iconsize={"md"}
          icon={"DashboardCustomize"}
          color={"blue-4"}
          bgColor={"white"}
        />
      </IconDropdown>

      {/* <IconDropdown onClick={openMapConfigurations}>
        <Icon
          iconsize={"md"}
          icon={"Settings"}
          color={"blue-4"}
          bgColor={"white"}
        />
      </IconDropdown> */}
    </>
  );
};